import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";

export default function Questions({ questions }) {
  const { t } = useTranslation();
  return (
    <Container sx={{ marginBottom: "3%" }}>
      <Box
        sx={{
          backgroundImage: `linear-gradient(to right, #7ABAF3, #8FBADFA3)`,
          width: "100%",
          padding: "80px",
          borderRadius: "20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: "30px",
            color: "white",
            marginBottom: "20px",
          }}
        >
          {t("Top Questions")}
        </Typography>

        {questions.map((q, i) => (
          <Accordion
            Key={i}
            sx={{
              padding: "10px",
              backgroundColor: "transparent",
              "&:before": { display: "none" },
            }}
            elevation={0}
            disableGutters
          >
            <AccordionSummary
              expandIcon={<AddIcon sx={{ color: "#6499F2" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography sx={{ color: "white", fontSize: "20px" }}>
                {t(q.Question)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ color: "#0A176E", fontSize: "16px" }}>
                {t(q.answer)}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
}
